import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import {config } from '../config'
import { ToastContainer, toast } from 'react-toastify';
import { Link } from "react-router-dom";

class PasswordReminder extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            email: '',
            responseText: '',
            errorText: ''
         }
    }
    handleSubmitClick(e){
        if(this.state.email === ''){
            this.setState({errorText: 'A mező nem lehet üres!'});
            return;
        }
        else{
            this.setState({errorText: ''});
        }
        //toast("Emlékeztető küldése");
        let url = config.API_URL + '/User/reminder.php';
        //console.log("calling url:" + url);

        axios({
            method: 'post',
            url: url,
            //headers: { 'content-type': 'application/json' },
            data: JSON.stringify(this.state)
        })
        .then(result => {
            //console.log("result", result);
            if(result.data.status === true){
                toast("Emlékeztető kiküldve", {type:'info'});
                let text = "A jelszó visszaállító e-mailt kiküldtük az Ön által megadott címre";
                this.setState({responseText: text});
            }
            else{
                this.setState({errorText: result.data.message});
            } 
        })
        .catch(error => alert(error.message));

    }

    render() { 
        return ( 
            <div id="kwizda-login-form" className="kwizda-form card"
            style={{margin: 'auto', marginBottom: 20}}>
                <h2 className="kwizda-page-title">Jelszó visszaállítás</h2>
                <label>E-mail</label>
                <input type="text" value={this.state.email} placeholder="E-mail"
                onChange={(e) => this.setState({email: e.target.value})}></input>
                {(!this.state.responseText)?
                <button id="kwizda-login-button"
                        className="kwizda-button"
                        type="submit" 
                        onClick={(e) => this.handleSubmitClick()}
                >
                        Új jelszó generálása
                </button>
                :
                <div style={{fontSize:18, marginTop:20}}>{this.state.responseText}</div>
                }
                {(this.state.errorText)?
                <div style={{fontSize:18, marginTop:20, color:'red'}}>{this.state.errorText}</div>
                :
                ""
                }
                <div style={{marginTop:20, textAlign:'center'}}>
                    <Link className="kwizda3-link" to="/bejelentkezes">Vissza</Link>
                </div>
                <ToastContainer />
            </div>
         );
    }
}
 
export default PasswordReminder;